import React from 'react';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setProtocolTab } from 'actions/protocols';
import { protocolRoutes } from 'routes/appRoutes';
import { CanUserViewSection } from 'appconstants/Permission';
import { getEncodedQueryParams } from 'helpers';

function RouteItem({ route, tag }) {
  const match = useRouteMatch(route.path);
  const formattedName = route.name.replace(/\s+/g, '-').toLowerCase();
  return (
    <li
      data-id={`${tag}-side-nav-item-${formattedName}`}
      className={`sideNavigation-item-wrapper ${match ? 'active' : ''}`}
    >
      <NavLink
        data-id={`${tag}-side-nav-anchor-${formattedName}`}
        className="sideNavigation-item"
        to={route.path}
      >
        {route.icon &&
          <div className="sideNavigation-icon-wrapper">
            <route.icon />
          </div>}
        <span className="sideNavigation-text">{route.name}</span>
      </NavLink>
    </li>
  );
}

function SideNavigation({ routes, tag }) {
  return (
    <ul data-id={`${tag}-side-nav-list`} className="sideNavigation-wrapper">
      {routes.map(route => <RouteItem key={route.path} route={route} tag={tag} />)}
    </ul>
  );
}

const PrtSections = (props) => {
  const { classes, id } = props;

  const accessibleRoutes = protocolRoutes.filter(route =>
    CanUserViewSection(route.permission)
  );

  const routesWithParams = accessibleRoutes.map(route => ({
    ...route,
    path: getEncodedQueryParams('', `${id}${route.path}`)
  }));
  return (
    <div className={classes?.sideNavWrapper}>
      <SideNavigation routes={routesWithParams} tag="protocol" />
    </div>
  );
};
const withConnectState = connect(
  state => ({
    prtInfo: state.prtDetails.prtInfo
  }),
  dispatch =>
    bindActionCreators(
      {
        onSetTab: setProtocolTab
      },
      dispatch
    )
);
export const ProtocolSections = compose(withConnectState)(PrtSections)
